var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5122 14.4585L13.2065 9.93408H8.86523V6.99805C8.86523 5.76025 9.47168 4.55371 11.416 4.55371H13.3896V0.70166C13.3896 0.70166 11.5986 0.395996 9.88623 0.395996C6.31104 0.395996 3.97412 2.56299 3.97412 6.48584V9.93408H0V14.4585H3.97412V25.396H8.86523V14.4585H12.5122Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.7319920fbf438e8197869dcaedb84a7b.svg";
export { ForwardRef as ReactComponent };